__turbopack_context__.v({
  "inputWrapper": "n7TkEa_inputWrapper",
  "shippingCostText": "n7TkEa_shippingCostText",
  "totalOfferPriceWithFeeQuote": "n7TkEa_totalOfferPriceWithFeeQuote",
});
